import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  max-width: 500px;
  width: 100%;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title: any = styled.h2<{ isUrgentText?: boolean }>`
  text-align: left;
  color: ${(props: any) => (props.isUrgentText ? "#FF3B30" : "#333333")};
  width: 100%;
  margin-bottom: 16px;
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: -0.01em;
`;

export const Message = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 160%;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
  width: 100%;
  margin-bottom: 24px;

  strong {
    font-weight: 700;
  }

  span {
    display: block;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 8px;
`;

export const UnderstandButton = styled.button`
  background-color: #304ffe;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 36px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(48, 79, 254, 0.2);

  &:hover {
    background-color: #1a39f7;
    box-shadow: 0 4px 8px rgba(48, 79, 254, 0.3);
  }

  &:active {
    background-color: #0026e6;
    box-shadow: 0 1px 3px rgba(48, 79, 254, 0.2);
    transform: translateY(1px);
  }
`;
